const SDK_LIST = {
  // 创新育种-乔东账户
  breeding: {
    appId: 1400693393,
    key: 'd780d845192ed67d43289da01774e03937d0250621f26ee50dfc952bab3524df',
    expireTime: 604800
  },
  // 野外采集
  clt: {
    appId: 1400693393,
    key: 'd780d845192ed67d43289da01774e03937d0250621f26ee50dfc952bab3524df',
    expireTime: 604800
  },
  // 种子生产
  fil: {
    appId: 1400693393,
    key: 'd780d845192ed67d43289da01774e03937d0250621f26ee50dfc952bab3524df',
    expireTime: 604800
  },
  // 正蓝旗-弃用
  zlq: {
    appId: 1400692040,
    key: 'e4a1dd70424fb9516e9c5d0f22b32ab9e85bb2e408d55755125be5c5f0c3103b',
    expireTime: 604800
  }
};


const getSDKAppID = () => {
  let res = null;
  let urlObj = transform(window.location.href);
  if (!urlObj || !urlObj.p || urlObj.p === '') return res;
  return SDK_LIST[urlObj.p]
};

const transform = str => {
  if (!str.includes('?')) return null;
  let params = str.split("?")[1].split("&");
  let obj = {};
  params.forEach(item => {
    obj[item.split("=")[0]] = item.split("=")[1]
  });
  return obj
};

export {getSDKAppID}



// WEBPACK FOOTER //
// ./src/util/call.js